import React, {Component} from "react";
import { react } from "mobx";
import { inject, observer } from "mobx-react";
import {Button} from "reactstrap";
import { IconeSetaSubir, IconeSetaDescer } from "./Icones";

@inject("store")
@observer
class CollapseItemTableIndicator extends Component {

    constructor(props) {
        super(props);
    }
    render() {
        return <Button outline className="collapseItem" active={this.props.expanded}>
                    {this.props.expanded ? <IconeSetaSubir tamanho="lg" /> : <IconeSetaDescer tamanho="lg" />}
               </Button>
    }
}

export {CollapseItemTableIndicator}


// WEBPACK FOOTER //
// ./src/modules/comum/components/CollapseItemTableIndicator.js